export default {
  UPDATE_ORGANIZATION_USERS(state, users) {
    state.organizationUsers = users
  },

  UPDATE_SENDER_ID(state, id) {
    state.id = id
  },

  UPDATE_SENDER_TYPE(state, type) {
    state.type = type
  }
}
